import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';


const WordpressEntwicklungText = () => {
    const { t } = useTranslations();

    return (
        <section className="about-area ptb-100">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <span className="sub-title">{t('wordpressDevelopment_text_subtitle')}</span>
                            <h2>{t('wordpressDevelopment_text_title')}</h2>
                            <p>{t('wordpressDevelopment_text_description')}</p>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            <Image src="/images/web-development/wordpressLaptop.webp" alt="simplify data - Wordpress Customizing"
                                width={0}
                                height={0}
                                sizes="100vw"
                                style={{ width: '60%', height: 'auto', borderRadius: '25px' }} />

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WordpressEntwicklungText;